import { CTManagerItemStock } from "projects/ct-manager/src/app/_core/classes/ct-manager-item-stock";

/**
 * Dati passati via MAT_DIALOG_DATA a CatalogEditComponent quando
 * viene aperto come dialog (es. da ItemSelectionComponent).
 *
 * La proprietà `onItemSaved` è un callback che il component invoca
 * dopo ogni salvataggio riuscito — usato per aggiornare la datatable
 * padre in tempo reale.
 *
 * La proprietà `lastCreatedStock` viene valorizzata da CatalogEditComponent
 * dopo il salvataggio e letta da ItemSelectionComponent alla chiusura
 * per filtrare/selezionare l'articolo creato.
 */
export class CatalogEditDialogData {

  /** Tipo articolo da passare come route param. Es: "item" | "module" */
  typePathValue: string = "item";

  /** Callback invocato dopo ogni salvataggio riuscito */
  onItemSaved: ((stock: CTManagerItemStock) => void) | null = null;

  /**
   * Ultimo stock creato/salvato nella sessione.
   * Viene scritto da CatalogEditComponent in _notifyItemSaved
   * e letto da ItemSelectionComponent nell'afterClosed della dialog.
   */
  lastCreatedStock: CTManagerItemStock | null = null;

  private constructor() {}

  public static create(): CatalogEditDialogData {
    return new CatalogEditDialogData();
  }

  setTypePathValue(value: string): CatalogEditDialogData {
    this.typePathValue = value;
    return this;
  }

  setOnItemSaved(fn: (stock: CTManagerItemStock) => void): CatalogEditDialogData {
    this.onItemSaved = fn;
    return this;
  }

}
